/**
 * Client-side derivations from a run row.
 *
 * "Stuck" is a UI concept, not a real status. The state machine itself
 * times out at 30 min, so any RUNNING row older than ~60 min almost
 * certainly means the post-worker `MarkSucceeded`/`MarkFailed` step never
 * fired (state machine crash, IAM blip, manual delete of the execution).
 * We surface that suspicion in the UI rather than writing it back to DDB
 * — see the rationale in the revised plan ("flag it in the API/UI response
 * so the dashboard clearly shows that something is suspicious").
 */

/** Mark a RUNNING row as suspicious after this much wall-clock has passed. */
export const STUCK_THRESHOLD_MS = 60 * 60 * 1000;

export function stuckThresholdMinutes(): number {
  return Math.round(STUCK_THRESHOLD_MS / 60_000);
}

export function isRunStuck(
  run: { status: string; queuedAt: string },
  now: number = Date.now(),
): boolean {
  if (run.status !== "RUNNING") return false;
  const t = Date.parse(run.queuedAt);
  if (!Number.isFinite(t)) return false;
  return now - t > STUCK_THRESHOLD_MS;
}
